import { TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
	container: {
		display: "flex",
		flexWrap: "nowrap",
		width: "100%",
	},
	field: {
		flex: 1,
		minWidth: 0,
	},
	field2: {
		flex: 2,
		minWidth: 0,
	},
	leftField: {
		"& .MuiOutlinedInput-root": {
			borderTopRightRadius: 0,
			borderBottomRightRadius: 0,
			borderRight: "none",
		},
	},
	rightField: {
		"& .MuiOutlinedInput-root": {
			borderTopLeftRadius: 0,
			borderBottomLeftRadius: 0,
		},
	},
	checkbox: {
		padding: 0,
		margin: 0,
	},
	inputAdornment: {
		margin: 0,
	},
	input: {
		paddingRight: theme.spacing(1),
	},
}));

interface Props {
	ladleLife: {
		HeatsOnLadle: number | null;
		ContactTimeOnLadle: number | null;
	};
	disabled: boolean;
	isSubmitLoading: boolean;
}

export const LadleLifeTrimTempCheckbox = ({
	ladleLife,
	disabled,
	isSubmitLoading,
}: Props) => {
	const classes = useStyles();

	return (
		<div className={classes.container}>
			<TextField
				className={`${classes.field} ${classes.leftField}`}
				label="Ladle Life"
				variant="outlined"
				disabled={disabled || isSubmitLoading}
				size="small"
				value={ladleLife.HeatsOnLadle || ""}
				InputProps={{
					style: {
						borderTopRightRadius: "0",
						borderBottomRightRadius: "0",
						borderRight: "none",
					},
				}}
			/>
			<TextField
				className={`${classes.field} ${classes.rightField}`}
				variant="outlined"
				disabled={disabled || isSubmitLoading}
				size="small"
				value={ladleLife.ContactTimeOnLadle}
				InputProps={{
					style: {
						borderTopLeftRadius: "0",
						borderBottomLeftRadius: "0",
					},
				}}
			/>
		</div>
	);
};
